import joi from 'joi-browser';

const messages = {
  'any.empty': 'Field is required',
  'any.required': 'Field is required',
  'string.base': 'Field is required',
  'number.base': 'Field is required',
  'date.base': 'Field is required',
  'array.includesRequiredUnknowns': 'Field is required',
  'string.email': 'Email is not valid',
  'string.min': min => `Must be at least ${min} symbols`,
  'string.max': max => `Must be at least ${max} symbols`,
  'number.min': min => `Must be larger than or equal to ${min}`,
  'array.min': min => `Choose at least ${min} item`,
  'date.max': 'Date cannot be later than current',
  'date.min': 'Date cannot be earlier than 1900',
  confirm_password: 'Must be equal to password',
  confirm: 'Must be equal to password',
};

// eslint-disable-next-line import/prefer-default-export
export function validate(schema, data) {
  const { error, value } = joi.validate(data, schema, { abortEarly: false, stripUnknown: true });
  const res = { data: value, errors: {} };

  if (error) {
    error.details.forEach((d) => {
      const { path, type, context } = d;
      const [field] = path;
      let msg;

      if (field === 'confirm') {
        msg = messages[field];
      } else if (!res.errors.hasOwnProperty(field)) {
        switch (type) {
          case 'string.min':
          case 'number.min':
          case 'array.min':
            msg = messages[type](context.limit);
            break;

          default:
            msg = messages[type];
        }
      }

      if (msg) {
        res.errors[field] = msg;
      } else {
        // eslint-disable-next-line no-console
        console.error('Unhandled error message', d);
      }
    });
  }

  return res;
}



// WEBPACK FOOTER //
// ./src/utils/validator.js